<template>
  <v-card class="pa-8 dashboard_cards">
    <div class="d-flex align-center">
      <img
        src="../../../assets/icons/leastactiveusericon.png"
        alt=""
        width="22px"
        class="mr-2"
      >
      <h4>Least Active Users</h4>
    </div>
    <div class="dashboard_card_count">
      <h1>{{ dashboardCounts.least_active_users || 0 }}</h1>
      <p>{{ lastUpdatedAt | diffHumans }}</p>
    </div>
  </v-card>
</template>
<script>
import moment from 'moment';
export default {
    name: 'DashboardLeastActiveUsers',
    filters: {
      diffHumans (val) {
        return moment(val).fromNow();
      },
    },
    computed: {
      dashboardCounts () {
        return this.$store.getters['dashboard/getDashboardCounts'];
      },
      lastUpdatedAt () {
        return this.$store.getters['dashboard/getLastUpdatedAt'];
      },
    },
    mounted () {
        this.lastUpdated();
    },
    methods: {
      lastUpdated () {
        this.$store.dispatch('dashboard/lastUpdatedAt', {
          updatedAt: moment().toISOString(),
        });
      },
    },
};
</script>
<style lang="scss" scoped>
    .dashboard_card_count{
    position: absolute;
    bottom: 10px;
}
.dashboard_cards h4 {
    font-size: 22px;
    font-weight: 400;
    position: relative;
}
</style>
